var map = {
	"./App.vue": "612c",
	"./AppFooter.vue": "f657",
	"./AppMenu.vue": "b982",
	"./BaseLocaleRouter.vue": "7381",
	"./Button.vue": "2a7d",
	"./CookieConsent.vue": "f64a",
	"./Star.vue": "1470",
	"./Typography.vue": "71f4",
	"./VisuallyHidden.vue": "b70d",
	"./markdown.vue": "d656",
	"./progress.vue": "d1ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2323";